<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import contenidoEmpresas from "@/components/widgets/contenidoEmpresas";
/**
 * Starter component
 */
export default {
  page: {
    title: "Empreas",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, contenidoEmpresas, PageHeader },
  data() {
    return {

    };
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="mb-4">
      <img :src="require('@/assets/images/recnet-header.png')" alt="Sesiones de reconstrucción"
        class="img-fluid w-100 rounded shadow-sm"
        style="max-height: 260px; object-fit: cover; object-position: center;" />
    </div>
    <contenidoEmpresas />
  </Layout>
</template>
